import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Users component
 *
 * This component renders child components that display and manage system users or client-specific users.
 *
 */
import { useClientIdParam } from '@src/hooks/useClientIdParam';
import { useClients } from '@src/hooks/useClients';
import { AdminTopNav } from '@src/components/Admin/AdminTopNav/AdminTopNav';
import { Alert, Card, CardContent } from '@guildeducationinc/recess';
import { useLocale } from 'pe-core-frontend';
import { ClientUsers } from './ClientUsers';
import { SystemUsers } from './SystemUsers';
export const Users = () => {
    const { t } = useLocale();
    const { clients } = useClients({ initialPageSize: 100 });
    const guildClient = clients.find(c => c.code === 'guild');
    const guildClientId = guildClient?.id;
    const clientId = useClientIdParam() || guildClientId;
    const isGuildClient = clientId === guildClientId;
    const client = clients.find(c => c.id === clientId);
    if (!client) {
        // ensure we have a client to pass to the components below
        const message = t('Client ID {clientId} not found.', { values: { clientId } });
        return (_jsxs("div", { children: [_jsx(AdminTopNav, { title: t('Users') }), _jsx(Card, { children: _jsx(CardContent, { children: _jsx(Alert, { display: true, type: 'warning', hideClose: true, children: message }) }) })] }));
    }
    if (isGuildClient) {
        return _jsx(SystemUsers, { client: client }, client.code);
    }
    else {
        return _jsx(ClientUsers, { client: client }, client.code);
    }
};
